import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../css/partners.css";

// Import partner logos
import northernTourism from "../images/partners-logo/northern-cape-tourism.png";
import dtic from "../images/EEA-logos-for-site/dtic.png";
import idc from "../images/EEA-logos-for-site/idc.png";
import northerncapetv from "../images/EEA-logos-for-site/northercapetv.jpg";
import G20 from '../images/partners-logo/g20.png';
import northernCapeGovernment from '../images/partners-logo/northern-cape-government.jpg';
import nceda from '../images/partners-logo/Northern-Cape-Economic-Development-Trade-and-Investment-Promotion-Agency.webp';

const Partners = () => {
  const partners = [
    { logo: northernCapeGovernment, description: "Strategic Partner" },
    { logo: idc, description: "Strategic Partner" },
    { logo: nceda, description: "Strategic Partner" },
    { logo: northernTourism, description: "Tourism Partner" },
    { logo: northerncapetv, description: "Media Partner" },
    { logo: G20, description: "Strategic Partner" },
   
    { logo: dtic, description: "Government Partner" },
   
    
  ];

  // Carousel settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    cssEase: "ease-in-out",
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className="partners-section">
      <div className="section-overlay"></div>
      
      <div className="content-container">
        <div className="section-header">
          <h2 className="section-subtitle">Our Valued Partnerships</h2>
          <h1 className="section-title">
            <span className="title-highlight">Trusted</span> Industry and Public Sector Partners
          </h1>
          <div className="divider"></div>
          <p className="section-description">
            With strategic partnerships across industries, Energy X Africa Conference and Exhibition collaborates with leading organizations
            to drive a breathrough industry initiative connecting Southern Africa's just energy transition future 
          </p>
        </div>

        <div className="partners-carousel">
          <Slider {...settings}>
            {partners.map((partner, index) => (
              <div key={index} className="partner-slide">
                <div className="logo-container">
                  <img 
                    src={partner.logo} 
                    alt={partner.description} 
                    className="partner-logo" 
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Partners;